import { Instance, types } from "mobx-state-tree";
import { ChatItemType } from "../ChatItemType";
import { BaseChatItem } from "./BaseChatItem";

export const DateSeparatorChatItem = types.compose(
  BaseChatItem,
  types.model({
    type: types.literal(ChatItemType.DateSeparator)
  })
);

export interface IDateSeparatorChatItem extends Instance<typeof DateSeparatorChatItem> {}
